import {FC, useEffect, useState} from 'react'
import Loader from 'react-loader-spinner'

type LoadingSpinnerProps = {
  color?: string
  type?:
    | 'Audio'
    | 'BallTriangle'
    | 'Bars'
    | 'Circles'
    | 'Grid'
    | 'Hearts'
    | 'Oval'
    | 'Puff'
    | 'Rings'
    | 'TailSpin'
    | 'ThreeDots'
    | 'Watch'
    | 'RevolvingDot'
    | 'Triangle'
    | 'Plane'
    | 'MutatingDots'
    | 'CradleLoader'
  height?: number
  width?: number
  classes?: string
  isLoading?: boolean
  ariaLabel?: string
  dataCy?: string
}

// Used by DownloadButton; intended as a design loader within the design system.
const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  color = '#00AEEA',
  type = 'TailSpin',
  height = 50,
  width = 50,
  classes = '',
  isLoading = false,
  ariaLabel = 'Loading',
  dataCy = 'loading',
}) => {
  const [displayLoader, setDisplayLoader] = useState(isLoading)

  useEffect(() => {
    setDisplayLoader(isLoading)
  }, [isLoading])

  if (!displayLoader) return null

  return (
    <span className={classes} data-cy={dataCy}>
      <progress
        aria-label={ariaLabel}
        style={{position: 'absolute', width: 1, height: 1, opacity: 0}}
      />
      <span aria-hidden="true">
        <Loader type={type} color={color} height={height} width={width} />
      </span>
    </span>
  )
}

export {LoadingSpinner}
